// extracted by mini-css-extract-plugin
module.exports = {"root":"AfterFrontImage_root__2eBEZ","title":"AfterFrontImage_title__2x1y4"};